// @ts-nocheck
import React from 'react';
import { Tile, Form, FormGroup, TextInput, Select, SelectItem, Button, Grid, Column, Stack } from '@carbon/react';
import { User } from '@carbon/icons-react';

function StudentProfile() {
  return (
    <div style={{ padding: '0 0 24px', marginLeft: 240 }}>
      <h2 style={{ marginBottom: 24, color: '#0f62fe', fontSize: '2rem', fontWeight: 600 }}>My Profile</h2>

      <Grid gutter={[16]}>
        <Column xs={24} md={8}>
          <Tile style={{ marginBottom: '16px', textAlign: 'center' }}>
            {/* Avatar placeholder */}
            style={{ backgroundColor: '#1890ff', marginBottom: 16 }}
            <h4 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '0 0 8px' }}>Grade 7 Student</h4>
            <span style={{ color: '#525252' }}>Middle School • Active Learner</span>
            <hr style={{ margin: '16px 0', border: '1px solid #e0e0e0' }} />
            <Stack direction="vertical" size="small" style={{ width: '100%' }}>
              <div>
                <span style={{ fontWeight: 'bold' }}>Learning Style</span>
                <br />
                <span style={{ color: '#525252' }}>Visual</span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>Preferred Pace</span>
                <br />
                <span style={{ color: '#525252' }}>Standard</span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>Curriculum</span>
                <br />
                <span style={{ color: '#525252' }}>Common Core</span>
              </div>
            </Stack>
          </Tile>
        </Column>

        <Column xs={24} md={16}>
          <Tile title="Profile Settings" style={{ marginBottom: '16px' }}>
            <Form layout="vertical">
              <Grid gutter={16}>
                <Column span={12}>
                  <FormGroup>
                    <Select id="grade-level" defaultValue="7" disabled labelText="Grade Level">
                      <SelectItem value="7" text="7th Grade" />
                    </Select>
                  </FormGroup>
                </Column>
                <Column span={12}>
                  <FormGroup>
                    <TextInput id="age-group" value="Middle School" disabled labelText="Age Group" />
                  </FormGroup>
                </Column>
              </Grid>

              <Grid gutter={16}>
                <Column span={12}>
                  <FormGroup>
                    <Select id="learning-style" defaultValue="visual" labelText="Learning Style">
                      <SelectItem value="visual" text="Visual" />
                      <SelectItem value="auditory" text="Auditory" />
                      <SelectItem value="kinesthetic" text="Kinesthetic" />
                      <SelectItem value="reading_writing" text="Reading/Writing" />
                    </Select>
                  </FormGroup>
                </Column>
                <Column span={12}>
                  <FormGroup>
                    <Select id="learning-pace" defaultValue="standard" labelText="Learning Pace">
                      <SelectItem value="accelerated" text="Accelerated" />
                      <SelectItem value="standard" text="Standard" />
                      <SelectItem value="extended_time" text="Extended Time" />
                    </Select>
                  </FormGroup>
                </Column>
              </Grid>

              <Grid gutter={16}>
                <Column span={12}>
                  <FormGroup>
                    <Select id="interaction-style" defaultValue="socratic" labelText="Interaction Style">
                      <SelectItem value="socratic" text="Socratic Method" />
                      <SelectItem value="direct" text="Direct Teaching" />
                      <SelectItem value="collaborative" text="Collaborative" />
                      <SelectItem value="independent" text="Independent" />
                    </Select>
                  </FormGroup>
                </Column>
                <Column span={12}>
                  <FormGroup>
                    <Select id="primary-language" defaultValue="en" labelText="Primary Language">
                      <SelectItem value="en" text="English" />
                      <SelectItem value="pt" text="Portuguese" />
                      <SelectItem value="es" text="Spanish" />
                    </Select>
                  </FormGroup>
                </Column>
              </Grid>

              <FormGroup>
                <Stack>
                  <Button kind="primary">Save Changes</Button>
                  <Button>Cancel</Button>
                </Stack>
              </FormGroup>
            </Form>
          </Tile>
        </Column>
      </Grid>
    </div>
  );
}

export default StudentProfile;
